<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD"
      (eventClick)="cambioPeriodo($event)">
  </app-filters>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="zona1">
      <div class="tablaZona1 w3-white">
        <div class="headers w3-titulo-contenidomenuSC">
          <div class="w3-half">
            <span class="w3-margin-left-contenido">{{ 'financiero.evaluacionIndicador.tituloEncabezadoTabla'| translate }}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles)}}</span>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
              [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcel()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="w3-row zonaTable w3-scroll">
          @if (dataOrdenado.length !== 0) {
            <table class="w3-table borderInf">
              <thead>
                <tr class="w3-center w3-table-title">
                  <th class="w3-border-right-balance stikyColum">{{'financiero.evaluacionIndicador.titulo1Tabla'|translate}}</th>
                  <th class="w3-border-right-balance stikyColum">{{'financiero.evaluacionIndicador.titulo2Tabla'|translate}}</th>
                  <th class="w3-border-right-balance stikyColum">{{'financiero.evaluacionIndicador.titulo3Tabla'|translate}}</th>
                  <th class="w3-border-right-balance stikyColum">{{'financiero.evaluacionIndicador.titulo4Tabla'|translate}}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of dataOrdenado; track item) {
                  @if (verTabla) {
                    <tr class="w3-table-trtd">
                      <td class="estiloNivel1 "><span class="w3-elemento-tableIndicador w3-margin-lelf-1roIndicador">{{item.idIndicador}}</span></td>
                      <td class="estiloNivel1"><span class="w3-elemento-tableIndicador w3-margin-lelf-1roIndicador">{{item.descripcion}}</span></td>
                      <td class="estiloNivel1"><span class="w3-elemento-tableIndicador"></span></td>
                      <td class="estiloNivel1"><span class="w3-elemento-tableIndicador"></span></td>
                    </tr>
                    @for (dat of item.series; track dat) {
                      <tr class="w3-table-trtd">
                        <td class="estiloNivel2 borderAllLow"><span class="w3-margin-lelf-1roIndicador">{{dat.idIndicador}}</span></td>
                          <td class="estiloNivel2 borderAllLow"><span class="w3-margin-lelf-2doIndicador">{{dat.descripcion}}</span></td>
                          <td class="w3-center estiloNivel2 borderAllLow"><span>{{dat.valor}}</span></td>
                          <td class="w3-center estiloNivel2 borderAllLow"><span>{{dat.alcance}}</span></td>
                        </tr>
                      }
                    }
                  }
              </tbody>
            </table>
          }@else { <app-skeleton-table [filas]="5" [columnas]="4"/> }
        </div>
      </div>
      <div class="graficaZona1">
        <div style="height: 1%;"></div>
        <ng-container>
          <div class="headersTransparent w3-titulo-contenidomenuSC">
            <span class="w3-margin-left-contenido"> {{'financiero.evaluacionIndicador.tituloEncabezadoGrafica1' | translate }} </span>
          </div>
          <div class="w3-row contenedorCompleto ">
            <div class="w3-row w3-white w3-margin-top" >
              @if (dataOrdenado.length > 0) {
                <app-tarjetas style="height: 8vh !important;"
                  [header]="'financiero.evaluacionIndicador.textoTarjeta' | translate"
                  [valueStr]="getCalificacionFormato()"
                  [footer]="escrituraPer(subTitles)" 
                  [color]="getColorCalificacion()"
                  [icon]="'none'">
                </app-tarjetas>
              }@else{ <app-skeleton-grafica/> }
            </div>
          </div>
        </ng-container>
        <div class="graficaPos w3-white" id="conteGraficaSup">
          <div class="w3-row">
            <div class="w3-titulo-contenidomenuSC">
              <div class="w3-half"></div>
              <div class="w3-rest w3-right">
                <!-- <mat-icon fontSet="material-icons-outlined" class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                  (click)="showEti1 = !showEti1" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
                  {{ showEti1 ? 'label_off' : 'label' }}
                </mat-icon> -->
                <mat-icon class="w3-button w3-dropdown-click iconoMen"
                  [ngStyle]="{'color':'gray'}" (click)="openModal('graf1')"
                  matTooltip="{{'financiero.evaluacionIndicador.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
                  [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuGraf1">
                  more_vert
                </mat-icon>
                <mat-menu #menuGraf1="matMenu">
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
                    [matMenuTriggerFor]="cambioGraf1">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.evaluacionIndicador.tooltipIcono1'|translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
                    (click)="exportarGraficaSup(1, 'Puntuacion')">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #cambioGraf1="matMenu">
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'bar'}"
                    [disabled]="tipo == 'bar'" (click)="opcionesGrafica1('bar')">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.evaluacionIndicador.tooltipIcono4'|translate}}</span>
                  </button>
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'line'}"
                    [disabled]="tipo == 'line'" (click)="opcionesGrafica1('line')">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.evaluacionIndicador.tooltipIcono5'|translate}}</span>
                  </button>
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'area'}"
                    [disabled]="tipo == 'area'" (click)="opcionesGrafica1('area')">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.evaluacionIndicador.tooltipIcono6'|translate}}</span>
                  </button>
                  <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'radar'}"
                    [disabled]="tipo == 'radar'" (click)="opcionesGrafica1('radar')">
                    <div class="w3-margin-right-contenido w3-button w3-dropdown-click"
                      [ngStyle]="{'color':'gray'}" style="transform: scale(0.9);">
                      <img src="../../../../assets/img/radar.png">
                    </div>
                    <span>{{'financiero.evaluacionIndicador.tooltipIcono3'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          @if (dataOrdenado.length !== 0) {
            <div class="graff">
              <app-graficador style="height: 60%;"
                [etiquetas]="showEti1"
                [data]="dataGraf1FormattedForGraficador"
                [labels]="labelsGraf1"
                [type]="tipoGraf1Actual"
                [axisX]="'Indicadores'"
                [axisY]="['Puntuación']"
                [zona]="1"
                [colors]="colorMulti"
                [formatEtiquetas]="false"
                [animations]="true"
                [speedAnimations]="1000",
                [sizeRadar]="59"
              ></app-graficador>
            </div>
          }@else{ <app-skeleton-grafica/> }
        </div>
      </div>
    </div>
    <div class="zona2 w3-white" id="conteGraficaInf">
      <div class="headers w3-titulo-contenidomenuSC">
        <div class="w3-half">
          <span class="w3-margin-left-contenido">{{ 'financiero.evaluacionIndicador.tituloEncabezadoGrafica2'| translate }}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{fechaG}}</span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="showEti2 = !showEti2" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
            {{ showEti2 ? 'label_off' : 'label' }}
          </mat-icon>
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="openModal('graf2')"
            matTooltip="{{'financiero.evaluacionIndicador.tooltipIcono2'|translate}}">
            zoom_out_map
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGraf2">
            more_vert
          </mat-icon>
          <mat-menu #menuGraf2="matMenu">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
              [matMenuTriggerFor]="cambioGraf2">
              <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
              <span>{{'financiero.evaluacionIndicador.tooltipIcono1'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
              (click)="exportarGraficaInf(2, 'financiero.evaluacionIndicador.tituloEncabezadoGrafica2')">
              <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
          <mat-menu #cambioGraf2="matMenu">
            <button mat-menu-item [ngClass]="{'w3-disabled': tipo2 === 'bar'}" [disabled]="tipo2 == 'bar'"
              (click)="opcionesGrafica2('bar')">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'financiero.evaluacionIndicador.tooltipIcono4'|translate}}</span>
            </button>
            <button mat-menu-item [ngClass]="{'w3-disabled': tipo2 === 'line'}" [disabled]="tipo2 == 'line'"
              (click)="opcionesGrafica2('line')">
              <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
              <span>{{'financiero.evaluacionIndicador.tooltipIcono5'|translate}}</span>
            </button>
            <button mat-menu-item [ngClass]="{'w3-disabled': tipo2 === 'area'}" [disabled]="tipo2 == 'area'"
              (click)="opcionesGrafica2('area')">
              <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
              <span>{{'financiero.evaluacionIndicador.tooltipIcono6'|translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="graficaPos2">
        @if (dataOrdenado.length !== 0) {
          <div style="height: 99%; width: 98%; margin-left: auto; margin-right: auto;">
            <app-graficador
              [etiquetas]="showEti2"
              [data]="dataGraf2FormattedForGraficador"
              [labels]="labelsGraf2"
              [type]="tipoGraf2Actual"
              [axisX]="'Períodos'"
              [axisY]="['Calificación']"
              [zona]="2"
              [colors]="color"
              [formatEtiquetas]="false"
              [animations]="true"
              [speedAnimations]="500"
              [legend]="{enabled: true, position: 'bottom'}"
            ></app-graficador>
          </div>
        }@else { <app-skeleton-grafica/> }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>
 <app-modal [isOpen]="modalOpen" (close)="modalOpen = false">
  <div modal-header>
    @if (graf1) {
      <span class="w3-margin-left-contenido">{{'financiero.evaluacionIndicador.tituloEncabezadoTabla' | translate }}</span>
    }
    @if (graf2) {
      <span class="w3-margin-left-contenido">{{'financiero.evaluacionIndicador.tituloEncabezadoGrafica2' | translate}}</span>
    }
    <span class="w3-margin-left-contenido">&bull;</span>
    <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles)}}</span>
  </div>
  <div modal-body style="width: 80vw;">
    @if (graf1) {
      <div class="w3-row contentGraf">
        <app-graficador
          [etiquetas]="showEti1"
          [data]="dataGraf1FormattedForGraficador"
          [labels]="labelsGraf1"
          [type]="tipoGraf1Actual"
          [axisX]="'Indicadores'"
          [axisY]="['Puntuación']"
          [zona]="3"
          [colors]="colorMulti"
          [formatEtiquetas]="false"
          [animations]="true"
          [speedAnimations]="1000"
          [legend]="{enabled: true, position: 'bottom'}"
        ></app-graficador>
      </div>
    }
    @if (graf2) {
      <div class="w3-row contentGraf">
        <app-graficador
          [etiquetas]="showEti2"
          [data]="dataGraf2FormattedForGraficador"
          [labels]="labelsGraf2"
          [type]="tipoGraf2Actual"
          [axisX]="'Períodos'"
          [axisY]="['Calificación']"
          [zona]="4"
          [colors]="color"
          [formatEtiquetas]="false"
          [animations]="true"
          [speedAnimations]="500"
          [legend]="{enabled: true, position: 'bottom'}"
        ></app-graficador>
      </div>
    }
  </div>
 </app-modal>